import { useState, useRef, useEffect } from 'react';

const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20white%20leather%20sneakers%20standing%20on%20terrazzo%20marble%20floor%20with%20soft%20pink%20neon%20accent%20light%20reflection%2C%20urban%20boutique%20display%20style%20photography%20with%20geometric%20tile%20patterns%20and%20clean%20modern%20aesthetic&width=600&height=400&seq=cat-shoes-v3&orientation=landscape',
    count: '2,340+',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20knit%20sweater%20draped%20over%20vintage%20wrought%20iron%20chair%20against%20exposed%20red%20brick%20wall%2C%20warm%20industrial%20loft%20aesthetic%20with%20soft%20afternoon%20sunlight%20casting%20patterns%20through%20window%20panes%20editorial%20fashion%20photography&width=600&height=400&seq=cat-hoodies-v3&orientation=landscape',
    count: '1,890+',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crisp%20white%20organic%20cotton%20t-shirt%20neatly%20folded%20on%20handmade%20terracotta%20clay%20plate%20with%20rough%20texture%2C%20earthy%20desert%20palette%20with%20dried%20pampas%20grass%20in%20background%2C%20warm%20golden%20hour%20lighting%20and%20boho%20editorial%20product%20style&width=600&height=400&seq=cat-tshirts-v3&orientation=landscape',
    count: '3,120+',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sleek%20black%20bomber%20jacket%20artfully%20draped%20over%20antique%20velvet%20armchair%20in%20dimly%20lit%20library%20setting%20with%20leather%20bound%20books%20on%20shelves%2C%20moody%20cinematic%20lighting%20with%20warm%20amber%20table%20lamp%20glow%20editorial%20fashion%20photography&width=600&height=400&seq=cat-jackets-v3&orientation=landscape',
    count: '1,560+',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tailored%20khaki%20chino%20trousers%20casually%20folded%20on%20weathered%20moss%20green%20concrete%20ledge%20with%20rain%20droplets%2C%20outdoor%20urban%20setting%20with%20soft%20overcast%20natural%20light%2C%20editorial%20streetwear%20product%20photography%20with%20textured%20organic%20backdrop&width=600&height=400&seq=cat-pants-v3&orientation=landscape',
    count: '2,050+',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20wool%20beanie%20and%20structured%20baseball%20cap%20arranged%20on%20white%20marble%20pedestal%20with%20gold%20ring%20accents%2C%20minimal%20gallery%20exhibition%20style%20photography%20with%20soft%20spotlight%20and%20clean%20negative%20space%2C%20luxury%20accessories%20editorial%20aesthetic&width=600&height=400&seq=cat-headwear-v3&orientation=landscape',
    count: '980+',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20loungewear%20set%20with%20coordinated%20jogger%20and%20crew%20neck%20neatly%20arranged%20on%20natural%20woven%20jute%20mat%20with%20coconut%20shell%20bowl%20and%20dried%20eucalyptus%20branches%2C%20scandinavian%20minimalist%20style%20with%20soft%20daylight%20and%20organic%20warmth&width=600&height=400&seq=cat-sets-v3&orientation=landscape',
    count: '1,340+',
  },
  {
    name: 'Underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20bamboo%20fiber%20underwear%20set%20artistically%20displayed%20on%20hand%20loomed%20linen%20fabric%20with%20dried%20baby%20breath%20flowers%20scattered%20around%2C%20soft%20morning%20mist%20lighting%20through%20sheer%20curtains%2C%20intimate%20serene%20editorial%20photography%20with%20gentle%20pastel%20tones&width=600&height=400&seq=cat-underwear-v3&orientation=landscape',
    count: '870+',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20athletic%20jersey%20hanging%20on%20rustic%20wooden%20locker%20hook%20with%20gym%20chalk%20dust%20on%20concrete%20wall%20background%2C%20dramatic%20cross%20lighting%20with%20cool%20blue%20and%20warm%20orange%20tones%2C%20sports%20editorial%20photography%20with%20raw%20athletic%20energy&width=600&height=400&seq=cat-jersey-v3&orientation=landscape',
    count: '1,120+',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20mens%20accessories%20including%20aviator%20sunglasses%20leather%20bracelet%20and%20minimalist%20ring%20arranged%20in%20dark%20green%20velvet%20jewelry%20tray%2C%20moody%20dramatic%20lighting%20with%20rich%20deep%20color%20saturation%2C%20luxury%20boutique%20editorial%20photography%20style&width=600&height=400&seq=cat-accessories-v3&orientation=landscape',
    count: '2,780+',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20camel%20leather%20tote%20bag%20resting%20on%20vintage%20steamer%20trunk%20with%20brass%20hardware%20and%20antique%20world%20map%20partially%20visible%2C%20adventure%20travel%20atmosphere%20with%20warm%20sepia%20tones%20and%20nostalgic%20editorial%20photography%20aesthetic&width=600&height=400&seq=cat-bags-v3&orientation=landscape',
    count: '1,450+',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hand%20stitched%20leather%20belt%20neatly%20coiled%20beside%20polished%20brass%20buckle%20on%20aged%20oak%20wine%20barrel%20surface%2C%20craftsman%20workshop%20atmosphere%20with%20wood%20shavings%20and%20warm%20tungsten%20light%2C%20artisan%20editorial%20product%20photography%20with%20rich%20texture%20details&width=600&height=400&seq=cat-belts-v3&orientation=landscape',
    count: '640+',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crystal%20cut%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20mirrored%20glass%20shelf%20beside%20white%20phalaenopsis%20orchid%20in%20full%20bloom%2C%20ethereal%20soft%20backlighting%20creating%20prismatic%20rainbow%20refractions%2C%20haute%20couture%20beauty%20editorial%20photography%20with%20dreamlike%20atmosphere&width=600&height=400&seq=cat-perfumes-v3&orientation=landscape',
    count: '920+',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20lifestyle%20items%20including%20notebook%20pen%20portable%20speaker%20and%20sunglasses%20arranged%20on%20natural%20bamboo%20mat%20with%20geometric%20ceramic%20props%2C%20japanese%20zen%20minimalism%20with%20clean%20lines%20and%20neutral%20earth%20tones%2C%20editorial%20flat%20lay%20photography%20with%20thoughtful%20composition&width=600&height=400&seq=cat-other-v3&orientation=landscape',
    count: '1,050+',
  },
];

export default function CategoryHub() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelectedCategory(cat.name);
    setDropdownOpen(false);
    window.open(cat.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="categories" className="py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <span className="inline-block px-5 py-2 rounded-full bg-background-50 text-foreground-700 text-sm font-medium">
            Category Hub
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-[1.1] tracking-tight mb-4">
          Explore Product
          <br />
          Categories
        </h2>

        <p className="text-foreground-600 text-base md:text-lg max-w-2xl mb-12">
          Browse our curated product categories with detailed spreadsheets for smart shopping decisions.
          Each category links to comprehensive comparison data on our main platform.
        </p>

        <div className="md:hidden mb-8" ref={dropdownRef}>
          <div className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between bg-white rounded-2xl px-5 py-4 text-foreground-950 text-sm font-medium border-2 border-background-200 hover:border-primary-400 transition-all cursor-pointer"
            >
              <span>{selectedCategory || 'Select a category...'}</span>
              <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl border border-background-200 shadow-xl overflow-hidden z-20 max-h-[70vh] overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat)}
                    className="w-full flex items-center gap-4 px-4 py-3 hover:bg-background-50 transition-colors cursor-pointer text-left border-b border-background-100 last:border-0"
                  >
                    <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
                      <img
                        src={cat.imageUrl}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-foreground-950 truncate">{cat.name}</p>
                      <p className="text-xs text-foreground-400">{cat.count} items</p>
                    </div>
                    <i className="ri-arrow-right-line text-foreground-400 text-sm"></i>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name + ' pandabuy spreadsheet category'}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="text-foreground-950 font-semibold text-base mb-3">{cat.name}</h3>
                <span
                  className={
                    'inline-block w-full px-4 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ' +
                    (index < 2
                      ? 'bg-foreground-950 text-white hover:bg-foreground-800'
                      : 'bg-white border-2 border-background-200 text-foreground-700 hover:border-foreground-300')
                  }
                >
                  View {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-2">{cat.count} items</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}